// import axios from "axios";
// import api from "./api";
// //const API_URL = "http://localhost:8080/api/auth";

// // export const register = (username, password) => {
// //   return axios.post(`${API_URL}/signup`, { username, password });
// // };



// export const registerUser = (payload) => {
//   return api.post("/api/auth/signup", payload);
// };

// export const loginUser = async (email, password) => {
//   const response = await api.post("/api/auth/login", { email, password });

//   if (response.data) {
//     localStorage.setItem("user", JSON.stringify(response.data));
//   }
//   return response.data;
// };

// export const logout = () => localStorage.removeItem("user");

// export const getCurrentUser = () => {
//   return JSON.parse(localStorage.getItem("user"));
// };



// // export const login = async (username, password) => {
// //   const resp = await axios.post(`${API_URL}/signin`, { username, password });
// //   // resp.data = { token, username } per backend
// //   if (resp.data && resp.data.token) {
// //     localStorage.setItem("token", resp.data.token);
// //     localStorage.setItem("username", resp.data.username);
// //   }
// //   return resp;
// // };

// // export const logout = () => {
// //   localStorage.removeItem("token");
// //   localStorage.removeItem("username");
// // };

// // export const getCurrentUser = () => {
// //   return localStorage.getItem("username");
// // };

// // export const getToken = () => localStorage.getItem("token");


// src/services/authService.js
 // src/services/authService.js

// -----------------------------
// REGISTER USER
// -----------------------------


// REGISTER USER
import axios from "axios";

const API_URL = "http://localhost:8080/api/auth";

const AuthService = {
  registerUser(name, email, phone, password) {
    return axios.post(`${API_URL}/signup`, {
      username: name,
      email,
      phone,
      password,
    });
  },

  loginUser(email, password) {
    return axios.post(`${API_URL}/login`, {
      email,
      password,
    });
  },

  logout() {
    localStorage.removeItem("user");
  },

  saveUser(user) {
    localStorage.setItem("user", JSON.stringify(user));
  },

  getCurrentUser() {
    return JSON.parse(localStorage.getItem("user"));
  },
};

export default AuthService;


